import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface TraceabilityVersion {
  id: number;
  qrProductDataId: number;
  value: any;
  versionNumber: number;
  createdById: number;
  eventHash: string;
  previousEventHash: string | null;
  signature: string;
  signerId: string;
  eventType: string;
  createdAt: string;
  createdBy?: {
    firstName: string;
    lastName: string;
    email: string;
  };
}

export interface VerificationResult {
  isValid: boolean;
  chainIntact: boolean;
  signatureValid: boolean;
  details: {
    currentHash: string;
    calculatedHash: string;
    previousHash: string | null;
  };
}

@Injectable({
  providedIn: 'root',
})
export class TraceabilityService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  /**
   * Fetches version history for a specific QR product data point
   */
  getHistory(qrProductDataId: number, limit = 50, offset = 0): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/qr-product-data/${qrProductDataId}/versions`, {
      params: { limit, offset },
    });
  }

  /**
   * Triggers a backend verification of a specific data point's integrity
   */
  verifyRecord(qrProductDataId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/qr-product-data/${qrProductDataId}/verify`);
  }

  /**
   * Fetches the organization's public keys for transparency/verification
   */
  getPublicKeys(): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/traceability/public-keys`);
  }

  /**
   * Fetches recent traceability audit log events across the organization
   */
  getRecentEvents(page = 1, limit = 10): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/qr-product-data/traceability/recent-events`, {
      params: { page: String(page), limit: String(limit) },
    });
  }

  /**
   * Fetches organization-wide traceability statistics
   */
  getStats(): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/qr-product-data/traceability/stats`);
  }
}
